import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { AppId } from './apps';

export interface AppProps {
  arg: Record<string, unknown> | null;
  argSeq: number;
}

type AppComp = LazyExoticComponent<ComponentType<AppProps>>;

export const APP_COMPONENTS: Record<AppId, AppComp> = {
  prompts: lazy(() => import('../apps/Prompts')),
  files: lazy(() => import('../apps/Files')),
  notes: lazy(() => import('../apps/Notes')),
  token: lazy(() => import('../apps/Token')),
  convert: lazy(() => import('../apps/Convert')),
  operator: lazy(() => import('../apps/Operator')),
  playground: lazy(() => import('../apps/Playground')),
  miner: lazy(() => import('../apps/Miner')),
  assistants: lazy(() => import('../apps/Assistants')),
  models: lazy(() => import('../apps/Models')),
  sysinfo: lazy(() => import('../apps/Sysinfo')),
  taskmgr: lazy(() => import('../apps/Taskmgr')),
  network: lazy(() => import('../apps/Network')),
  leaderboard: lazy(() => import('../apps/Leaderboard')),
  wallet: lazy(() => import('../apps/Wallet')),
  readme: lazy(() => import('../apps/Readme')),
  settings: lazy(() => import('../apps/Settings')),
};
